//#region REACT
import { useEffect } from 'react';
import React, { useState } from "react";
import axios from "axios";
import { endpoints } from '../../../core/constants';
import { useTranslation } from "react-i18next";
//#endregion

//#region COMPONENTS
import SingleSelectionDropdown from '../../Elements/SingleSelectionDropdown';
import Type from '../../Elements/Typography';
import DataCard from '../../Widgets/DataCard/DataCard';
//#endregion

//#region STYLES
import './DashboardCards.scss';
//#endregion

//#region UTILS
import { groupBy } from '../../../tools';
import { CardType } from '../../../models/internal_api/cardInterfaces.model';
import { formatDate } from '../../../core/utils';
//#endregion

export default function DashboardCards() {
    //TRANSLATION INIT
    const { t } = useTranslation();

    var dateLessSevenDays = new Date();
    dateLessSevenDays.setDate(dateLessSevenDays.getDate() - 7);

    const [incidents, setIncidents] = useState<object>({});
    const [dateFilter, setDateFilter] = useState<Date>(dateLessSevenDays);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const headers = {
        //'cache': 'default',
        'mode': 'cors',
        'credentials': 'include',
        'content-type': 'application/json'
    };

    console.log("down events", endpoints.incidents + "?open_date=" + formatDate(dateFilter));

    // CALL ACCORDING TO DATE FILTER SELECTED    
    useEffect(() => {
        axios.get(endpoints.incidents + "?open_date=" + formatDate(dateFilter), { headers: headers, withCredentials: true })
            .then(response => {
                console.log("monitored_houses: ", sessionStorage.getItem('monitored_houses'));
                console.log("affected_user: ", response.data.result.map((m) => m.affected_user_id));
                var result = response.data.result.filter((f) => sessionStorage.getItem('monitored_houses')?.includes(f.affected_user_id));
                setIncidents(groupBy(result, 'category'));
                setIsLoading(false);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dateFilter]);

    const cardData = [{
        id: 'temperature',
        title: t("temperature"),
        icon: { imagePath: '', altText: '' },
        metrics: [{ name: t("highTemperature"), value: (Number(incidents["High Temperature"]?.length ?? 0)) }, { name: t("lowTemperature"), value: (Number(incidents["Low Temperature"]?.length ?? 0)) }],
        type: CardType.UP_LOW
    },
    {
        id: 'humidity',
        title: t("humidity"),
        icon: { imagePath: '', altText: '' },
        metrics: [{ name: t("highHumidity"), value: (Number(incidents["High Humidity"]?.length ?? 0)) }, { name: t("lowHumidity"), value: (Number(incidents["Low Humidity"]?.length ?? 0)) }],
        type: CardType.UP_LOW
    },
    {
        id: 'air',
        title: t("airQuality"),
        icon: { imagePath: '', altText: '' },
        metrics: [{ name: 'CO2', value: (Number(incidents["High CO2 Levels"]?.length ?? 0)) }, { name: t("gasSmoke"), value: (Number(incidents["High Gas&Smoke"]?.length ?? 0)) }],
        type: CardType.MULTIPLE,
    },
    {
        id: 'inactivity',
        title: t("inactivity"),
        icon: { imagePath: '', altText: '' },
        metrics: [{ name: t("inactivity"), value: (Number(incidents["Suspicious Activity"]?.length ?? 0)) }],
        type: CardType.NONE
    }];

    return (
        <div className='DashboardCards'>
            <Type.p className="titleForm DashboardCards__title">
                <b>{t("dashboard.timeframe")}</b>
            </Type.p>
            <SingleSelectionDropdown
                placeholder="Placeholder"
                searchable={false}
                selected={1}
                options={[
                    { id: 1, name: t("last7days") },
                    { id: 2, name: t("last15days") },
                    { id: 3, name: t("last30days") },
                ]}
                onChangeSelection={(e) => {
                    var dynamicDate = new Date();
                    dynamicDate.setDate(e?.id === 1 ? dynamicDate.getDate() - 7 : e?.id === 2 ? dynamicDate.getDate() - 15 : dynamicDate.getDate() - 30);
                    setDateFilter(dynamicDate);
                }}
            />
            <div className="DashboardCards__cards">
                <DataCard card={cardData[0]} isLoading={isLoading} />
                <DataCard card={cardData[1]} isLoading={isLoading} />
                <DataCard card={cardData[2]} isLoading={isLoading} />
                <DataCard card={cardData[3]} isLoading={isLoading} />
            </div>
        </div>
    );
}